<div class="faq__section" id="faq">
    <h4>
        FAQ's
        <span *ngIf="name && ticker">
            for {{ name }} ({{ ticker }})
        </span>
    </h4>

    <ul class="faq-list">
        <li *ngFor="let panel of panels"
            class="faq-item"
            [class.active]="isOpen(panel.id)">

            <!-- Header -->
            <button class="panel-header"
                    (click)="togglePanel(panel.id)"
                    [attr.aria-expanded]="isOpen(panel.id)">

                <h3 [innerHTML]="panel.title" class="mb-0"></h3>

                <span class="arrow-icon">
                    <img
                      [src]="isOpen(panel.id)
                        ? '../../../assets/images/arrow-up.svg'
                        : '../../../assets/images/arrow-down.svg'">
                </span>
            </button>

            <!-- Content -->
            <div class="panel-content"
                 *ngIf="isOpen(panel.id)">
                <div [innerHTML]="panel.content"></div>
            </div>

        </li>
    </ul>
</div>
